import * as Yup from 'yup';

export const monthlyValidationSchema = Yup.object().shape({
  scopeMonthlyData: Yup.array().of(
    Yup.object().shape({
      value: Yup.number()
        .nullable().typeError('Value must be a number') // Error message if it's not a number
    })
  ).test(
    'at-least-one-filled',
    'At least one value must be entered',
    function (scopeMonthlyData) {
      // Ensure that scopeMonthlyData is always defined and contains valid values
      return scopeMonthlyData
        ? scopeMonthlyData.some((data) => data?.value !== null && data?.value !== undefined && !isNaN(data.value))
        : false; // Default to false if undefined
    }
  )
});